(function () {

    "use strict";
    function basicTaskController($q, entityTaskService, $rootScope, $mdDialog, $window) {

        var vm = this;
        vm.$onInit = function () {
        };

        vm.$onChanges = function () {
        };

        vm.outTask = function () {
            addSignDocument();

            function addSignDocument() {

                vm.selectedItem = {
                    idFileContainer: vm.editContoller.entity.idFileContainer,
                    idFileItem: vm.editContoller.entity.id,
                    extension: vm.editContoller.entity.extension,
                    allowSignDoc: true,
                    isPdf: true,
                    allowPrint: false
                };
                defineSignatureArea();
            }

            function defineSignatureArea() {
                vm.params = {};

                vm.postMessageData = {
                    event: 'DefineSignatureArea'
                };

                removeEventListener();

                var viewer = $window.document.getElementById('framedocuviewer').contentWindow;
                viewer.postMessage(vm.postMessageData, '*');

                vm.listener = function (e) {
                    vm.params = e.data.params;
                    vm.signDocument();
                };

                addEventListener();
            }

            function addEventListener() {
                if ($window.addEventListener) {
                    $window.addEventListener('message', vm.listener);
                }
                else {
                    $window.attachEvent('onmessage', vm.listener);
                }
            }

            function removeEventListener() {
                if ($window.removeEventListener) {
                    $window.removeEventListener('message', vm.listener);
                }
                else {
                    $window.detachEvent('onmessage', vm.listener);
                }
            }
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        };

        vm.signDocument = function () {
            vm.signatureCanvasModalEnabled = true;

            $mdDialog.show({
                controller: $rootScope.$new(true),
                contentElement: '#signatureCanvasModalContainer',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: true
            }).then(function (result) {
                //WacomGSS.STU.close();
                //vm.signatureCanvasModalEnabled = false;
                //removeEventListener();
                //clearSelectionArea();

                //vm.addSignDocAction = true;
                //vm.signDocContent = result.file;

                //if (vm.selectedOption.AskConfirmation) {
                //    vm.showOutputConfirmation = true;
                //} else {
                //    vm.checkConfirmPassword();
                //}

            }).catch(function (data) {
                //WacomGSS.STU.close();
                //if (!data.cancelled) {
                //    toaster.error($translate.instant("SIGNATURE.SIGNATURE_ERROR"));
                //}
                //removeEventListener();
                //disableActionReplace();
                //clearSelectionArea();
                //vm.signatureCanvasModalEnabled = false;
            });
        };
    }

    basicTaskController.$inject = ["$q", "solpheo.entityTaskService", "$rootScope", "$mdDialog", "$window"];

    angular.module("sphforms.main")
        .component("sphformsSingBasicTask", {
            transclude: true,
            controller: basicTaskController,
            bindings: {
                editContoller: '<',
                actionName: '<'
            },
            templateUrl: "modules/main/components/basicTask/singBasicTask.template.html"
        });

}());
